import { FC, lazy } from 'react';

const Page = lazy(() => import('./page'));

export const ShippersView: FC = () => {
  return <Page />;
};
